import styled from 'styled-components';
import { DatePicker, Radio } from 'antd';

export const CustomInputContainer = styled.div`
	.ant-input {
		border-radius: 4px !important;
	}
`;

export const DatePickerWrapper = styled(DatePicker)`
	width: 100%;
	border-radius: 4px !important;

	.ant-picker-input > input {
		border-radius: 4px !important;
	}
`;

export const RadioWrapper = styled(Radio)`
	font-size: 0.79rem;
`;
